/*************** Scroll to top ***************/
var scrollpos = window.scrollY;
var scrolltotop = document.querySelector('#scroll-to-top');

window.addEventListener('scroll', function(){
  scrollpos = window.scrollY;

  if(scrollpos > 100){
    scrolltotop.classList.add('show-me');

    if (scrolltotop) {
      scrolltotop.addEventListener("click", scrollWindow);
    }
  }
  else {
    scrolltotop.classList.remove("show-me");
  }

});

const scrollWindow = function () {
  if (window.scrollY > 100) {
    $('html,body').animate({
      scrollTop: 0
    }, 0);
  }
};
